import { render } from "./Fault.vue?vue&type=template&id=61c45b0f"
import script from "./Fault.vue?vue&type=script&lang=js"
export * from "./Fault.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__